import { FolderableAppType } from 'FoldersApp/enums/folderable-app-type.enum';
export const ACTION_NOTES = 'notes';
export const ACTION_REPORT = 'report';
export const ACTION_DUPLICATE = 'duplicate';
export const ACTION_DELETE = 'delete';
/**
 * Dropdown configuration with extra actions for analysis plan items in list page.
 */
export const LIST_PAGE_DROPDOWN_ACTIONS = {
    title: {
        label: '',
        icon: 'icon-dots-more',
    },
    list: [
        {
            type: 'option',
            label: 'Notes',
            value: ACTION_NOTES,
            icon: 'icon-notes-add',
        },
        {
            type: 'option',
            label: 'Generate Report',
            value: ACTION_REPORT,
            icon: 'icon-report',
        },
        {
            type: 'option',
            label: 'Duplicate',
            value: ACTION_DUPLICATE,
            icon: 'icon-duplicate',
        },
        {
            type: 'option',
            label: 'Delete',
            value: ACTION_DELETE,
            icon: 'icon-delete',
        },
    ],
};
// Filters sidebar style classes
export const IS_PANEL_SIDEBAR_SHOWN = 'is-panel-sidebar-shown';
export const IS_PANEL_SIDEBAR_HIDDEN = 'is-panel-sidebar-hidden';
export const ANALYSIS_PLAN_FOLDERABLE_APP_CONFIG = {
    appName: 'InteractiveAnalysisApp',
    folderableAppType: FolderableAppType.LIST_PAGE,
    itemNamePlural: 'Interactive Analysis',
};
export const ANALYSIS_PLAN_FOLDERABLE_MODAL_APP_CONFIG = {
    appName: 'InteractiveAnalysisApp',
    folderableAppType: FolderableAppType.MODAL,
    itemNamePlural: 'Interactive Analysis',
};
